import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import React, { useEffect, useRef } from "react";
import FormTextField from "../../components/formFields/FormTextField";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { Button } from "@progress/kendo-react-buttons";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { LoadingPanel } from "../../components/layout/Loading";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  createPriority,
  findAllActivePriority,
  getAllPriority,
  getPriorityById,
  updatePriority,
} from "./services/priority.services";
import {
  clearPriorityDetails,
  closePriorityDrawerOpen,
} from "./prioritySlice";
import { closed } from "../../components/muidrawer/muiDrawerSlice";
import { STATUSARRAY } from "../../_contstants/common";
import { Typography } from "@progress/kendo-react-common";

const CreatePriority: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);

  // const PriorityList = useAppSelector((state) => state.priority.PriorityList);
  const PriorityDetail = useAppSelector(
    (state) => state.priority.PriorityDetail
  );
  const ProrityGUID = useAppSelector((state) => state.muidrawer.data);
  const formLoading = useAppSelector((state) => state.priority.formLoading);
  const isIndirect = useAppSelector((state) => state.muidrawer.isIndirect);
  const priorityDrawerOpen = useAppSelector(
    (state) => state.priority.priorityDrawerOpen
  );
  useEffect(() => {
    return () => {
      dispatch(clearPriorityDetails());
      if (priorityDrawerOpen) {
        dispatch(closePriorityDrawerOpen());
      } else {
        dispatch(closed());
      }
    };
  }, []);

  useEffect(() => {
    if (ProrityGUID) {
      dispatch(getPriorityById(ProrityGUID));
    }
  }, [ProrityGUID]);

  /* This Function calls when Form submit button Clicked */
  const handleSubmit = async (values: any) => {
    try {
      if (!ProrityGUID) {
        const payload = {
          priority_guid: ProrityGUID,
          priority: values.priority,
          isactive: values.isactive === 1,
        };
        const response = await dispatch(createPriority(payload));
        if (response?.meta?.requestStatus === "fulfilled") {
          if (priorityDrawerOpen) {
            dispatch(closePriorityDrawerOpen());
          } else {
            dispatch(closed());
          }
          dispatch(clearPriorityDetails());
          isIndirect || priorityDrawerOpen
            ? dispatch(findAllActivePriority())
            : dispatch(getAllPriority());
        }
      } else {
        const payload = {
          priority_guid: ProrityGUID,
          priority: values.priority,
          isactive: values.isactive === 1,
        };
        const response = await dispatch(updatePriority(payload));
        if (response?.meta?.requestStatus === "fulfilled") {
          if (priorityDrawerOpen) {
            dispatch(closePriorityDrawerOpen());
          } else {
            dispatch(closed());
          }
          dispatch(clearPriorityDetails());
          isIndirect || priorityDrawerOpen
            ? dispatch(findAllActivePriority())
            : dispatch(getAllPriority());
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  const handleFormClose = () => {
    if (priorityDrawerOpen) {
      dispatch(closePriorityDrawerOpen());
    } else {
      dispatch(closed());
    }
  };

  if (formLoading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <Form
      onSubmit={handleSubmit}
      initialValues={PriorityDetail}
      render={(formRenderProps: FormRenderProps) => (
        <FormElement style={{ width: "100%" }}>
          <GridLayout
            style={{
              display: "flex",
              flexWrap: "wrap",
            }}
            gap={{ rows: 10 }}
            cols={[{ width: "100%" }]}
          >
            <GridLayoutItem>
              <Typography.h4 className="m-0">
                {ProrityGUID ? "Update Priority" : "Add Priority"}
              </Typography.h4>
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                name="priority"
                label="Priority"
                placeholder="i.e. High"
                component={FormTextField}
                validator={requiredValidator}
                astrike={true}
              />
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                id={"IsActive"}
                name={"isactive"}
                label={"Status"}
                component={FormSelectionField}
                validator={requiredValidator}
                astrike={true}
                options={STATUSARRAY?.map((status: any) => {
                  return {
                    value: status.value,
                    label: status.label,
                  };
                })}
              />
            </GridLayoutItem>
            <GridLayoutItem
              colSpan={3}
              style={{
                textAlign: "end",
                marginTop: "10px",
                width: "100%",
              }}
            >
              <ButtonWithLoading
                label={ProrityGUID ? "Update" : "Create"}
                type="submit"
                disabled={!formRenderProps.allowSubmit || formLoading}
                loading={formLoading}
              />
              <Button
                type="button"
                fillMode={"outline"}
                themeColor={"primary"}
                style={{ marginLeft: 4 }}
                onClick={handleFormClose}
              >
                Cancel
              </Button>
            </GridLayoutItem>
          </GridLayout>
        </FormElement>
      )}
    />
  );
};

export default CreatePriority;
